import { Col, Radio, Row, Space, Typography } from 'antd';
import { format } from 'date-fns';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { DatePicker, TimePicker } from 'src/app/components/antd';
import { useProgramStepContext } from 'src/features/programsV2/contexts/ProgramStepContext';
import { PublishStepForm } from 'src/features/programsV2/schemas/publishStepSchema';

import { ProgramFormItem } from '../../ProgramFormItem';

const { Text } = Typography;

interface ProgramPublishContentProps {
  isPublished: boolean;
}

export const ProgramPublishContent: FC<ProgramPublishContentProps> = ({
  isPublished,
}) => {
  const { control, watch } = useFormContext<PublishStepForm>();
  const { programApiInitialValues } = useProgramStepContext();

  const releaseDate = programApiInitialValues?.publishStep?.date;

  const disableSchedule = watch().publish !== 'scheduled' || isPublished;

  return (
    <>
      <ProgramFormItem
        name='publish'
        control={control}
        renderItem={({ field: { value, ...field } }) => (
          <Space direction='vertical' size={24} style={{ width: '100%' }}>
            <Space style={{ width: '100%' }} direction='horizontal' size={16}>
              <Radio
                {...field}
                checked={value === 'scheduled'}
                value={'scheduled'}
                disabled={isPublished}
              >
                Agendar para
              </Radio>

              <Radio
                {...field}
                checked={value === 'now'}
                value={'now'}
                disabled={isPublished}
              >
                Publicar agora
              </Radio>
            </Space>

            <Row style={{ width: '100%' }}>
              <Col span={12} style={{ paddingRight: '12px' }}>
                <ProgramFormItem
                  control={control}
                  name='date'
                  label='Data'
                  renderItem={({ field }) => (
                    <DatePicker
                      {...field}
                      format='DD/MM/YYYY'
                      disabled={disableSchedule}
                      placeholder='Selecione uma data'
                      style={{ width: '100%' }}
                    />
                  )}
                />
              </Col>
              <Col span={12} style={{ paddingLeft: '12px' }}>
                <ProgramFormItem
                  control={control}
                  name='time'
                  label='Hora'
                  renderItem={({ field }) => (
                    <TimePicker
                      {...field}
                      showSecond={false}
                      disabled={disableSchedule}
                      placeholder='Selecione um horário'
                      style={{ width: '100%' }}
                      showNow={false}
                      format={'HH:mm'}
                    />
                  )}
                />
              </Col>
            </Row>
          </Space>
        )}
      />

      {isPublished && (
        <Text type='success' style={{ marginTop: 16 }}>
          Este programa já foi publicado
        </Text>
      )}

      {releaseDate && !isPublished && (
        <Text type='success' style={{ marginTop: 16 }}>
          Este programa foi agendado para publicação em{' '}
          {format(new Date(releaseDate), 'dd/MM/yyyy HH:mm:ss')}{' '}
        </Text>
      )}
    </>
  );
};
